module.exports = __webpack_public_path__ + "img/place.8e8fad9e.svg";